
      const { okapi, config, modules } = {
  "okapi": {
    "url": "https:\u002F\u002Fokapi-fivecolleges-test.folio.ebsco.com",
    "tenant": "fs00001006"
  },
  "config": {
    "logCategories": "core,path,action,xhr",
    "logPrefix": "--",
    "maxUnpagedResourceCount": 5000,
    "showPerms": false,
    "rtr": {
      "idleSessionTTL": "7d"
    },
    "useSecureTokens": true
  },
  "modules": {
    "app": [
      {
        "handlerName": "eventHandler",
        "displayName": "ui-agreements.meta.title",
        "route": "\u002Ferm",
        "home": "\u002Ferm\u002Fagreements",
        "queryResource": "query",
        "okapiInterfaces": {
          "configuration": "2.0 3.0 4.0 5.0",
          "erm": "7.0",
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "order-lines": "2.0 3.0",
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Fagreements",
        "getModule": function anonymous(
) {
return require('@folio/agreements').default;
},
        "description": "ERM agreement functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "displayName": "ui-bulk-edit.meta.title",
        "route": "\u002Fbulk-edit",
        "home": "\u002Fbulk-edit",
        "okapiInterfaces": {
          "bulk-operations": "1.0",
          "entity-types": "2.0",
          "users": "15.4 16.0"
        },
        "optionalOkapiInterfaces": {},
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fbulk-edit",
        "getModule": function anonymous(
) {
return require('@folio/bulk-edit').default;
},
        "description": "Description for bulk edit",
        "version": "4.2.4"
      },
      {
        "displayName": "ui-checkin.meta.title",
        "route": "\u002Fcheckin",
        "queryResource": "query",
        "okapiInterfaces": {
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "configuration": "2.0",
          "inventory": "10.0 11.0 12.0 13.0 14.0",
          "loan-policy-storage": "1.0 2.0",
          "users": "15.0 16.0",
          "feesfines": "17.0 18.0 19.0"
        },
        "optionalOkapiInterfaces": {
          "circulation-bff-loans": "1.0"
        },
        "module": "@folio\u002Fcheckin",
        "getModule": function anonymous(
) {
return require('@folio/checkin').default;
},
        "description": "Item Check-in",
        "version": "10.0.2"
      },
      {
        "displayName": "ui-checkout.meta.title",
        "route": "\u002Fcheckout",
        "queryResource": "query",
        "okapiInterfaces": {
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "add-info": "0.1",
          "configuration": "2.0",
          "loan-policy-storage": "1.0 2.0",
          "users": "16.1",
          "inventory": "10.0 11.0 12.0 13.0 14.0",
          "automated-patron-blocks": "0.1",
          "notes": "4.0"
        },
        "optionalOkapiInterfaces": {
          "circulation-bff-loans": "1.2"
        },
        "module": "@folio\u002Fcheckout",
        "getModule": function anonymous(
) {
return require('@folio/checkout').default;
},
        "description": "Item Check-out",
        "version": "11.0.3"
      },
      {
        "displayName": "ui-circulation-log.meta.title",
        "route": "\u002Fcirculation-log",
        "home": "\u002Fcirculation-log",
        "okapiInterfaces": {
          "service-points": "3.3",
          "circulation-logs": "1.2"
        },
        "optionalOkapiInterfaces": {
          "data-export-spring": "1.0 2.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fcirculation-log",
        "getModule": function anonymous(
) {
return require('@folio/circulation-log').default;
},
        "description": "Description for circulation logs",
        "version": "5.0.1"
      },
      {
        "displayName": "ui-courses.meta.title",
        "route": "\u002Fcr",
        "queryResource": "query",
        "okapiInterfaces": {
          "course-reserves-storage": "0.2",
          "term-storage": "0.1",
          "department-storage": "0.1",
          "course-type-storage": "0.1",
          "processing-status-storage": "0.1",
          "copyright-status-storage": "0.1",
          "role-storage": "0.1",
          "locations": "3.0",
          "item-storage": "7.1 8.0 9.0 10.0",
          "loan-types": "2.2"
        },
        "module": "@folio\u002Fcourses",
        "getModule": function anonymous(
) {
return require('@folio/courses').default;
},
        "description": "Maintain courses and reserve items for them",
        "version": "6.1.2"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-dashboard.meta.title",
        "route": "\u002Fdashboard",
        "home": "\u002Fdashboard",
        "queryResource": "query",
        "okapiInterfaces": {
          "servint": "4.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components",
          "@k-int\u002Fstripes-kint-components"
        ],
        "module": "@folio\u002Fdashboard",
        "getModule": function anonymous(
) {
return require('@folio/dashboard').default;
},
        "description": "Dashboard app for configurable FOLIO widgets",
        "version": "6.1.1"
      },
      {
        "stripesDeps": [
          "@folio\u002Fstripes-data-transfer-components"
        ],
        "displayName": "ui-data-export.meta.title",
        "route": "\u002Fdata-export",
        "queryResource": "query",
        "okapiInterfaces": {
          "data-export": "5.0"
        },
        "module": "@folio\u002Fdata-export",
        "getModule": function anonymous(
) {
return require('@folio/data-export').default;
},
        "description": "Data export manager",
        "version": "6.2.0"
      },
      {
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-data-transfer-components"
        ],
        "displayName": "ui-data-import.meta.title",
        "route": "\u002Fdata-import",
        "queryResource": "query",
        "okapiInterfaces": {
          "data-import": "3.2",
          "source-manager-job-executions": "3.4",
          "data-import-converter-storage": "1.5"
        },
        "module": "@folio\u002Fdata-import",
        "getModule": function anonymous(
) {
return require('@folio/data-import').default;
},
        "description": "Data Import manager",
        "version": "8.0.5"
      },
      {
        "displayName": "ui-eholdings.meta.title",
        "route": "\u002Feholdings",
        "okapiInterfaces": {
          "eholdings": "4.0",
          "tags": "1.0",
          "erm": "1.0 2.0 3.0 4.0 5.0 6.0 7.0"
        },
        "module": "@folio\u002Feholdings",
        "getModule": function anonymous(
) {
return require('@folio/eholdings').default;
},
        "description": "FOLIO UI module for eHoldings",
        "version": "10.0.1"
      },
      {
        "displayName": "ui-export-manager.meta.title",
        "route": "\u002Fexport-manager",
        "okapiInterfaces": {
          "configuration": "2.0",
          "data-export-spring": "1.0 2.0",
          "organizations.organizations": "1.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fexport-manager",
        "getModule": function anonymous(
) {
return require('@folio/export-manager').default;
},
        "description": "Description for export manager",
        "version": "3.2.0"
      },
      {
        "displayName": "ui-finance.meta.title",
        "moduleName": "Finance",
        "route": "\u002Ffinance",
        "home": "\u002Ffinance",
        "okapiInterfaces": {
          "acquisitions-units": "1.1",
          "configuration": "2.0",
          "finance.budgets": "1.3 2.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.fiscal-years": "1.0 2.0",
          "finance.fund-types": "1.0 2.0",
          "finance.funds": "3.0",
          "finance.group-fiscal-year-summaries": "1.0",
          "finance.group-fund-fiscal-years": "1.0 2.0",
          "finance.groups": "1.0 2.0",
          "finance.ledger-rollovers-errors": "1.0",
          "finance.ledger-rollovers-logs": "1.0",
          "finance.ledger-rollovers-progress": "1.0",
          "finance.ledger-rollovers": "1.0 2.0",
          "finance.ledgers": "1.5 2.0",
          "finance.transactions": "6.0",
          "invoice": "7.0",
          "locations": "3.0",
          "location-units": "2.0",
          "orders": "12.1",
          "order-lines": "2.0 3.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Ffinance",
        "getModule": function anonymous(
) {
return require('@folio/finance').default;
},
        "description": "Description for ui-finance",
        "version": "7.0.1"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-inventory.meta.title",
        "route": "\u002Finventory",
        "home": "\u002Finventory?filters=staffSuppress.false",
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-inventory-components",
          "@folio\u002Fstripes-marc-components"
        ],
        "okapiInterfaces": {
          "alternative-title-types": "1.0",
          "call-number-types": "1.0",
          "browse": "0.6 1.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "classification-types": "1.1",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "contributor-types": "2.0",
          "data-export": "5.0",
          "data-import-converter-storage": "1.3 1.4 1.5",
          "electronic-access-relationships": "1.0",
          "holdings-note-types": "1.0",
          "holdings-sources": "1.0",
          "holdings-storage": "3.0 4.4 5.0 6.0 7.0 8.0",
          "holdings-types": "1.0",
          "identifier-types": "1.1",
          "ill-policies": "1.0",
          "instance-formats": "2.0",
          "instance-note-types": "1.0",
          "instance-relationship-types": "1.0",
          "instance-statuses": "1.0",
          "instance-storage": "7.0 8.0 9.0 10.0 11.0",
          "instance-types": "2.0",
          "inventory-record-bulk": "1.0",
          "inventory": "10.10 11.0 12.0 13.0 14.0",
          "item-note-types": "1.0",
          "item-storage": "8.0 9.0 10.0",
          "loan-types": "2.0",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.0",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "search": "0.7 1.0 1.3",
          "source-storage-records": "3.3",
          "statistical-code-types": "1.0",
          "statistical-codes": "1.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "copycat-imports": "1.1",
          "copycat-profiles": "1.2",
          "remote-storage-mappings": "1.0 2.0",
          "acquisitions-units": "1.1",
          "orders": "11.0 12.0",
          "orders.holding-summary": "1.0",
          "order-lines": "2.0 3.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "pieces": "3.0",
          "titles": "1.2",
          "browse": "1.5"
        },
        "module": "@folio\u002Finventory",
        "getModule": function anonymous(
) {
return require('@folio/inventory').default;
},
        "description": "Inventory manager",
        "version": "12.0.16"
      },
      {
        "displayName": "ui-invoice.meta.title",
        "route": "\u002Finvoice",
        "queryResource": "query",
        "okapiInterfaces": {
          "acquisition-methods": "1.0",
          "acquisitions-units": "1.1",
          "batch-group": "1.0",
          "batch-voucher.batch-voucher-exports": "1.0",
          "batch-voucher.batch-vouchers": "2.0",
          "batch-voucher.export-configurations": "1.0",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "finance.budgets": "1.3 2.0",
          "finance.exchange-rate": "1.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.fiscal-years": "2.0",
          "finance.funds": "1.0 2.0 3.0",
          "identifier-types": "1.2",
          "invoice": "7.0",
          "material-types": "2.2",
          "order-lines": "2.0 3.0",
          "orders": "11.0 12.0",
          "organizations-storage.categories": "1.1",
          "organizations.organizations": "1.0",
          "pieces": "3.0",
          "tags": "1.0",
          "users": "15.1 16.0",
          "voucher-number": "1.0",
          "voucher": "2.1"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Finvoice",
        "getModule": function anonymous(
) {
return require('@folio/invoice').default;
},
        "description": "Invoice",
        "version": "6.1.3"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-licenses.meta.title",
        "route": "\u002Flicenses",
        "home": "\u002Flicenses",
        "queryResource": "query",
        "okapiInterfaces": {
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Flicenses",
        "getModule": function anonymous(
) {
return require('@folio/licenses').default;
},
        "description": "ERM License functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "displayName": "ui-marc-authorities.meta.title",
        "route": "\u002Fmarc-authorities",
        "okapiInterfaces": {
          "search": "1.0",
          "browse": "1.0",
          "source-storage-records": "3.3",
          "marc-records-editor": "6.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-authority-components"
        ],
        "module": "@folio\u002Fmarc-authorities",
        "getModule": function anonymous(
) {
return require('@folio/marc-authorities').default;
},
        "description": "MARC Authorities module",
        "version": "6.0.1"
      },
      {
        "displayName": "ui-orders.meta.title",
        "route": "\u002Forders",
        "home": "\u002Forders\u002Flines",
        "okapiInterfaces": {
          "acquisition-order-events": "1.0",
          "acquisition-order-line-events": "1.0",
          "acquisition-methods": "1.0",
          "acquisitions-units": "1.1",
          "configuration.prefixes": "1.0",
          "configuration.reasons-for-closure": "1.0",
          "configuration.suffixes": "1.0",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "contributor-types": "2.0",
          "erm": "4.0 5.0 6.0 7.0",
          "finance.budgets": "1.3 2.0",
          "finance.exchange-rate": "1.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.funds": "3.0",
          "finance.transactions": "6.0",
          "holdings-storage": "4.4 5.0 6.0 7.0 8.0",
          "identifier-types": "1.2",
          "instance-formats": "2.0",
          "instance-relationship-types": "1.0",
          "instance-statuses": "1.0",
          "instance-types": "2.0",
          "inventory": "10.10 11.0 12.0 13.0 14.0",
          "invoice": "7.0",
          "loan-types": "2.2",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.2",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "order-lines": "3.3",
          "order-templates": "1.0",
          "orders": "12.1",
          "orders.export-history": "1.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "organizations-storage.organization-types": "1.0",
          "pieces": "2.0 3.0",
          "po-number": "1.0",
          "receiving": "1.0 2.0",
          "search": "0.6 1.0",
          "tags": "1.0",
          "template-engine": "2.0",
          "titles": "1.2",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "consortium-search": "2.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-template-editor"
        ],
        "module": "@folio\u002Forders",
        "getModule": function anonymous(
) {
return require('@folio/orders').default;
},
        "description": "Description for orders",
        "version": "7.0.5"
      },
      {
        "displayName": "ui-organizations.meta.title",
        "moduleName": "Organizations",
        "route": "\u002Forganizations",
        "home": "\u002Forganizations",
        "okapiInterfaces": {
          "acquisition-methods": "1.0",
          "banking-information": "1.0",
          "data-export-spring": "1.0 2.0",
          "configuration": "2.0",
          "organizations.organizations": "1.0",
          "organizations-storage.addresses": "1.1",
          "organizations-storage.categories": "1.1",
          "organizations-storage.organization-types": "1.0",
          "organizations-storage.contacts": "2.0",
          "organizations-storage.emails": "1.1",
          "organizations-storage.interfaces": "2.1",
          "organizations-storage.phone-numbers": "2.0",
          "organizations-storage.privileged-contacts": "1.0",
          "organizations-storage.settings": "1.0",
          "organizations-storage.urls": "1.1",
          "tags": "1.0",
          "users": "15.1 16.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Forganizations",
        "getModule": function anonymous(
) {
return require('@folio/organizations').default;
},
        "description": "Organizations",
        "version": "5.2.0"
      },
      {
        "displayName": "ui-reading-room.meta.title",
        "route": "\u002Freading-room",
        "okapiInterfaces": {
          "users": "16.3",
          "reading-room-patron-permission": "1.0",
          "reading-room": "1.0"
        },
        "optionalOkapiInterfaces": {
          "notes": "4.0",
          "automated-patron-blocks": "0.1",
          "feesfines": "19.1"
        },
        "module": "@folio\u002Freading-room",
        "getModule": function anonymous(
) {
return require('@folio/reading-room').default;
},
        "description": "Reading Room Access",
        "version": "1.1.1"
      },
      {
        "displayName": "ui-receiving.meta.title",
        "route": "\u002Freceiving",
        "home": "\u002Freceiving",
        "okapiInterfaces": {
          "acquisition-piece-events": "1.0",
          "acquisitions-units": "1.1",
          "circulation": "9.5 10.0 11.0 12.0 13.0 14.0",
          "configuration": "2.0",
          "contributor-types": "2.0",
          "holdings-storage": "4.2 5.0 6.0 7.0 8.0",
          "identifier-types": "1.2",
          "instance-formats": "2.0",
          "instance-types": "2.0",
          "inventory": "10.0 11.0 12.0 13.2 14.0",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.2",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "order-lines": "2.0 3.0",
          "orders": "11.0 12.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "pieces": "3.1",
          "receiving": "2.0",
          "search": "0.5 0.6 1.0",
          "tags": "1.0",
          "titles": "1.2",
          "users": "16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "consortium-search": "2.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Freceiving",
        "getModule": function anonymous(
) {
return require('@folio/receiving').default;
},
        "description": "Description for receiving",
        "version": "6.0.6"
      },
      {
        "displayName": "ui-requests.meta.title",
        "route": "\u002Frequests",
        "home": "\u002Frequests?filters=&sort=requestDate",
        "queryResource": "query",
        "okapiInterfaces": {
          "cancellation-reason-storage": "1.1",
          "circulation": "14.2",
          "inventory": "10.0 11.0 12.0 13.0 14.0",
          "request-storage": "6.0",
          "pick-slips": "0.1",
          "search-slips": "0.1",
          "automated-patron-blocks": "0.1"
        },
        "module": "@folio\u002Frequests",
        "getModule": function anonymous(
) {
return require('@folio/requests').default;
},
        "description": "Requests manager",
        "version": "11.0.9"
      },
      {
        "displayName": "ui-serials-management.meta.title",
        "route": "\u002Fserials-management",
        "home": "\u002Fserials-management\u002Fserials",
        "queryResource": "query",
        "okapiInterfaces": {
          "serials-management": "1.0"
        },
        "optionalOkapiInterfaces": {
          "orders": "12.1",
          "order-lines": "3.0",
          "organizations": "2.0",
          "material-types": "2.2",
          "pieces": "3.0",
          "acquisitions-units": "1.1",
          "holdings-storage": "6.0 7.0 8.0",
          "locations": "3.0",
          "titles": "1.2",
          "identifier-types": "1.2"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components",
          "@k-int\u002Fstripes-kint-components"
        ],
        "module": "@folio\u002Fserials-management",
        "getModule": function anonymous(
) {
return require('@folio/serials-management').default;
},
        "description": "FOLIO app for serials-management",
        "version": "1.1.2"
      },
      {
        "displayName": "ui-task-list.meta.title.tasks",
        "moduleName": "Tasks",
        "route": "\u002Ftasks",
        "home": "\u002Ftasks",
        "queryResource": "query",
        "okapiInterfaces": {
          "tasks": "1.0",
          "users": "15.0 16.0"
        },
        "module": "@folio-eis\u002Ftask-list",
        "getModule": function anonymous(
) {
return require('@folio-eis/task-list').default;
},
        "description": "FOLIO task management app",
        "version": "6.0.0"
      },
      {
        "displayName": "ui-users.meta.title",
        "route": "\u002Fusers",
        "home": "\u002Fusers?sort=name",
        "queryResource": "query",
        "actionNames": [
          "stripesHome",
          "usersSortByName"
        ],
        "okapiInterfaces": {
          "users": "16.3",
          "configuration": "2.0",
          "permissions": "5.7",
          "login": "7.3",
          "users-bl": "6.1",
          "staging-users": "1.0",
          "tags": "1.0"
        },
        "optionalOkapiInterfaces": {
          "actual-cost-record-storage": "0.4",
          "add-info": "0.1",
          "automated-patron-blocks": "0.1",
          "batch-print": "1.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "consortia": "1.0",
          "feesfines": "19.1",
          "loan-policy-storage": "1.0 2.0",
          "loan-storage": "4.0 5.0 6.0 7.0",
          "notes": "4.0",
          "request-storage": "2.5 3.0 4.0 5.0 6.0",
          "reading-room-patron-permission": "1.0",
          "roles": "1.0",
          "circulation-bff-loans": "1.3",
          "users-keycloak": "1.0"
        },
        "module": "@folio\u002Fusers",
        "getModule": function anonymous(
) {
return require('@folio/users').default;
},
        "description": "User management",
        "version": "11.0.13"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-lists.meta.title",
        "route": "\u002Flists",
        "home": "\u002Flists",
        "okapiInterfaces": {
          "lists": "1.0",
          "fqm-query": "2.0",
          "entity-types": "2.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Flists",
        "getModule": function anonymous(
) {
return require('@folio/lists').default;
},
        "description": "FOLIO Reporting Machine Lists",
        "version": "3.1.6"
      }
    ],
    "settings": [
      {
        "displayName": "ui-acquisition-units.meta.title",
        "queryResource": "query",
        "route": "\u002Facquisition-units",
        "okapiInterfaces": {
          "acquisitions-units": "1.1",
          "users": "15.1 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Facquisition-units",
        "getModule": function anonymous(
) {
return require('@folio/acquisition-units').default;
},
        "description": "Acquisition units",
        "version": "5.2.0"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-agreements.meta.title",
        "route": "\u002Ferm",
        "home": "\u002Ferm\u002Fagreements",
        "queryResource": "query",
        "okapiInterfaces": {
          "configuration": "2.0 3.0 4.0 5.0",
          "erm": "7.0",
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "order-lines": "2.0 3.0",
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Fagreements",
        "getModule": function anonymous(
) {
return require('@folio/agreements').default;
},
        "description": "ERM agreement functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "displayName": "ui-calendar.meta.title",
        "route": "\u002Fcalendar",
        "okapiInterfaces": {
          "calendar": "5.0",
          "service-points": "3.0",
          "users": "16.0"
        },
        "module": "@folio\u002Fcalendar",
        "getModule": function anonymous(
) {
return require('@folio/calendar').default;
},
        "description": "Calendar settings",
        "version": "11.0.3"
      },
      {
        "displayName": "ui-circulation.meta.title",
        "route": "\u002Fcirculation",
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-template-editor"
        ],
        "okapiInterfaces": {
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "configuration": "2.0",
          "fixed-due-date-schedules-storage": "2.0",
          "loan-policy-storage": "1.0 2.0",
          "template-engine": "2.0",
          "patron-notice-policy-storage": "0.11",
          "location-units": "2.0",
          "locations": "3.0",
          "feesfines": "16.0 17.0 18.0 19.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "ecs-tlr": "1.0"
        },
        "module": "@folio\u002Fcirculation",
        "getModule": function anonymous(
) {
return require('@folio/circulation').default;
},
        "description": "Circulation manager",
        "version": "10.0.1"
      },
      {
        "displayName": "ui-courses.meta.title",
        "route": "\u002Fcr",
        "queryResource": "query",
        "okapiInterfaces": {
          "course-reserves-storage": "0.2",
          "term-storage": "0.1",
          "department-storage": "0.1",
          "course-type-storage": "0.1",
          "processing-status-storage": "0.1",
          "copyright-status-storage": "0.1",
          "role-storage": "0.1",
          "locations": "3.0",
          "item-storage": "7.1 8.0 9.0 10.0",
          "loan-types": "2.2"
        },
        "module": "@folio\u002Fcourses",
        "getModule": function anonymous(
) {
return require('@folio/courses').default;
},
        "description": "Maintain courses and reserve items for them",
        "version": "6.1.2"
      },
      {
        "stripesDeps": [
          "@folio\u002Fstripes-data-transfer-components"
        ],
        "displayName": "ui-data-export.meta.title",
        "route": "\u002Fdata-export",
        "queryResource": "query",
        "okapiInterfaces": {
          "data-export": "5.0"
        },
        "module": "@folio\u002Fdata-export",
        "getModule": function anonymous(
) {
return require('@folio/data-export').default;
},
        "description": "Data export manager",
        "version": "6.2.0"
      },
      {
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-data-transfer-components"
        ],
        "displayName": "ui-data-import.meta.title",
        "route": "\u002Fdata-import",
        "queryResource": "query",
        "okapiInterfaces": {
          "data-import": "3.2",
          "source-manager-job-executions": "3.4",
          "data-import-converter-storage": "1.5"
        },
        "module": "@folio\u002Fdata-import",
        "getModule": function anonymous(
) {
return require('@folio/data-import').default;
},
        "description": "Data Import manager",
        "version": "8.0.5"
      },
      {
        "queryResource": "query",
        "displayName": "ui-developer.meta.title",
        "route": "\u002Fdeveloper",
        "actionNames": [
          "stripesHome",
          "stripesAbout"
        ],
        "okapiInterfaces": {},
        "optionalOkapiInterfaces": {
          "app-manager": "1.0",
          "capabilities": "1.0",
          "capability-sets": "1.0"
        },
        "module": "@folio\u002Fdeveloper",
        "getModule": function anonymous(
) {
return require('@folio/developer').default;
},
        "description": "Developer settings",
        "version": "9.0.0"
      },
      {
        "displayName": "ui-eholdings.meta.title",
        "route": "\u002Feholdings",
        "okapiInterfaces": {
          "eholdings": "4.0",
          "tags": "1.0",
          "erm": "1.0 2.0 3.0 4.0 5.0 6.0 7.0"
        },
        "module": "@folio\u002Feholdings",
        "getModule": function anonymous(
) {
return require('@folio/eholdings').default;
},
        "description": "FOLIO UI module for eHoldings",
        "version": "10.0.1"
      },
      {
        "displayName": "ui-finance.meta.title",
        "moduleName": "Finance",
        "route": "\u002Ffinance",
        "home": "\u002Ffinance",
        "okapiInterfaces": {
          "acquisitions-units": "1.1",
          "configuration": "2.0",
          "finance.budgets": "1.3 2.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.fiscal-years": "1.0 2.0",
          "finance.fund-types": "1.0 2.0",
          "finance.funds": "3.0",
          "finance.group-fiscal-year-summaries": "1.0",
          "finance.group-fund-fiscal-years": "1.0 2.0",
          "finance.groups": "1.0 2.0",
          "finance.ledger-rollovers-errors": "1.0",
          "finance.ledger-rollovers-logs": "1.0",
          "finance.ledger-rollovers-progress": "1.0",
          "finance.ledger-rollovers": "1.0 2.0",
          "finance.ledgers": "1.5 2.0",
          "finance.transactions": "6.0",
          "invoice": "7.0",
          "locations": "3.0",
          "location-units": "2.0",
          "orders": "12.1",
          "order-lines": "2.0 3.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Ffinance",
        "getModule": function anonymous(
) {
return require('@folio/finance').default;
},
        "description": "Description for ui-finance",
        "version": "7.0.1"
      },
      {
        "displayName": "ui-gobi-settings.meta.title",
        "queryResource": "query",
        "route": "\u002Fgobi-integration",
        "okapiInterfaces": {
          "custom-mapping": "1.0",
          "users": "15.1 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fgobi-settings",
        "getModule": function anonymous(
) {
return require('@folio/gobi-settings').default;
},
        "description": "GOBI integration settings",
        "version": "3.2.0"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-inventory.meta.title",
        "route": "\u002Finventory",
        "home": "\u002Finventory?filters=staffSuppress.false",
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-inventory-components",
          "@folio\u002Fstripes-marc-components"
        ],
        "okapiInterfaces": {
          "alternative-title-types": "1.0",
          "call-number-types": "1.0",
          "browse": "0.6 1.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "classification-types": "1.1",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "contributor-types": "2.0",
          "data-export": "5.0",
          "data-import-converter-storage": "1.3 1.4 1.5",
          "electronic-access-relationships": "1.0",
          "holdings-note-types": "1.0",
          "holdings-sources": "1.0",
          "holdings-storage": "3.0 4.4 5.0 6.0 7.0 8.0",
          "holdings-types": "1.0",
          "identifier-types": "1.1",
          "ill-policies": "1.0",
          "instance-formats": "2.0",
          "instance-note-types": "1.0",
          "instance-relationship-types": "1.0",
          "instance-statuses": "1.0",
          "instance-storage": "7.0 8.0 9.0 10.0 11.0",
          "instance-types": "2.0",
          "inventory-record-bulk": "1.0",
          "inventory": "10.10 11.0 12.0 13.0 14.0",
          "item-note-types": "1.0",
          "item-storage": "8.0 9.0 10.0",
          "loan-types": "2.0",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.0",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "search": "0.7 1.0 1.3",
          "source-storage-records": "3.3",
          "statistical-code-types": "1.0",
          "statistical-codes": "1.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "copycat-imports": "1.1",
          "copycat-profiles": "1.2",
          "remote-storage-mappings": "1.0 2.0",
          "acquisitions-units": "1.1",
          "orders": "11.0 12.0",
          "orders.holding-summary": "1.0",
          "order-lines": "2.0 3.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "pieces": "3.0",
          "titles": "1.2",
          "browse": "1.5"
        },
        "module": "@folio\u002Finventory",
        "getModule": function anonymous(
) {
return require('@folio/inventory').default;
},
        "description": "Inventory manager",
        "version": "12.0.16"
      },
      {
        "displayName": "ui-invoice.meta.title",
        "route": "\u002Finvoice",
        "queryResource": "query",
        "okapiInterfaces": {
          "acquisition-methods": "1.0",
          "acquisitions-units": "1.1",
          "batch-group": "1.0",
          "batch-voucher.batch-voucher-exports": "1.0",
          "batch-voucher.batch-vouchers": "2.0",
          "batch-voucher.export-configurations": "1.0",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "finance.budgets": "1.3 2.0",
          "finance.exchange-rate": "1.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.fiscal-years": "2.0",
          "finance.funds": "1.0 2.0 3.0",
          "identifier-types": "1.2",
          "invoice": "7.0",
          "material-types": "2.2",
          "order-lines": "2.0 3.0",
          "orders": "11.0 12.0",
          "organizations-storage.categories": "1.1",
          "organizations.organizations": "1.0",
          "pieces": "3.0",
          "tags": "1.0",
          "users": "15.1 16.0",
          "voucher-number": "1.0",
          "voucher": "2.1"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Finvoice",
        "getModule": function anonymous(
) {
return require('@folio/invoice').default;
},
        "description": "Invoice",
        "version": "6.1.3"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-licenses.meta.title",
        "route": "\u002Flicenses",
        "home": "\u002Flicenses",
        "queryResource": "query",
        "okapiInterfaces": {
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Flicenses",
        "getModule": function anonymous(
) {
return require('@folio/licenses').default;
},
        "description": "ERM License functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "displayName": "ui-marc-authorities.meta.title",
        "route": "\u002Fmarc-authorities",
        "okapiInterfaces": {
          "search": "1.0",
          "browse": "1.0",
          "source-storage-records": "3.3",
          "marc-records-editor": "6.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-authority-components"
        ],
        "module": "@folio\u002Fmarc-authorities",
        "getModule": function anonymous(
) {
return require('@folio/marc-authorities').default;
},
        "description": "MARC Authorities module",
        "version": "6.0.1"
      },
      {
        "displayName": "ui-myprofile.meta.title",
        "route": "\u002Fmyprofile",
        "links": {
          "userDropdown": [
            {
              "caption": "ui-myprofile.userDropdown.changePassword.caption",
              "route": "\u002Fsettings\u002Fmyprofile\u002Fpassword",
              "check": "isLocalLogin"
            }
          ]
        },
        "module": "@folio\u002Fmyprofile",
        "getModule": function anonymous(
) {
return require('@folio/myprofile').default;
},
        "description": "My profile",
        "version": "9.2.0"
      },
      {
        "displayName": "ui-notes.meta.title",
        "route": "\u002Fnotes",
        "okapiInterfaces": {
          "notes": "4.0"
        },
        "queryResource": "query",
        "module": "@folio\u002Fnotes",
        "getModule": function anonymous(
) {
return require('@folio/notes').default;
},
        "description": "Note types manager",
        "version": "10.0.0"
      },
      {
        "displayName": "ui-oai-pmh.meta.title",
        "route": "\u002Foai-pmh",
        "okapiInterfaces": {
          "configuration": "2.0",
          "oai-pmh": "3.0"
        },
        "module": "@folio\u002Foai-pmh",
        "getModule": function anonymous(
) {
return require('@folio/oai-pmh').default;
},
        "description": "OAI-PMH manager",
        "version": "5.2.0"
      },
      {
        "displayName": "ui-orders.meta.title",
        "route": "\u002Forders",
        "home": "\u002Forders\u002Flines",
        "okapiInterfaces": {
          "acquisition-order-events": "1.0",
          "acquisition-order-line-events": "1.0",
          "acquisition-methods": "1.0",
          "acquisitions-units": "1.1",
          "configuration.prefixes": "1.0",
          "configuration.reasons-for-closure": "1.0",
          "configuration.suffixes": "1.0",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "contributor-types": "2.0",
          "erm": "4.0 5.0 6.0 7.0",
          "finance.budgets": "1.3 2.0",
          "finance.exchange-rate": "1.0",
          "finance.expense-classes": "2.0 3.0",
          "finance.funds": "3.0",
          "finance.transactions": "6.0",
          "holdings-storage": "4.4 5.0 6.0 7.0 8.0",
          "identifier-types": "1.2",
          "instance-formats": "2.0",
          "instance-relationship-types": "1.0",
          "instance-statuses": "1.0",
          "instance-types": "2.0",
          "inventory": "10.10 11.0 12.0 13.0 14.0",
          "invoice": "7.0",
          "loan-types": "2.2",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.2",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "order-lines": "3.3",
          "order-templates": "1.0",
          "orders": "12.1",
          "orders.export-history": "1.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "organizations-storage.organization-types": "1.0",
          "pieces": "2.0 3.0",
          "po-number": "1.0",
          "receiving": "1.0 2.0",
          "search": "0.6 1.0",
          "tags": "1.0",
          "template-engine": "2.0",
          "titles": "1.2",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "consortium-search": "2.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-template-editor"
        ],
        "module": "@folio\u002Forders",
        "getModule": function anonymous(
) {
return require('@folio/orders').default;
},
        "description": "Description for orders",
        "version": "7.0.5"
      },
      {
        "displayName": "ui-organizations.meta.title",
        "moduleName": "Organizations",
        "route": "\u002Forganizations",
        "home": "\u002Forganizations",
        "okapiInterfaces": {
          "acquisition-methods": "1.0",
          "banking-information": "1.0",
          "data-export-spring": "1.0 2.0",
          "configuration": "2.0",
          "organizations.organizations": "1.0",
          "organizations-storage.addresses": "1.1",
          "organizations-storage.categories": "1.1",
          "organizations-storage.organization-types": "1.0",
          "organizations-storage.contacts": "2.0",
          "organizations-storage.emails": "1.1",
          "organizations-storage.interfaces": "2.1",
          "organizations-storage.phone-numbers": "2.0",
          "organizations-storage.privileged-contacts": "1.0",
          "organizations-storage.settings": "1.0",
          "organizations-storage.urls": "1.1",
          "tags": "1.0",
          "users": "15.1 16.0"
        },
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Forganizations",
        "getModule": function anonymous(
) {
return require('@folio/organizations').default;
},
        "description": "Organizations",
        "version": "5.2.0"
      },
      {
        "displayName": "ui-remote-storage.meta.title",
        "route": "\u002Fremote-storage",
        "okapiInterfaces": {
          "locations": "3.0",
          "remote-storage-configurations": "1.1",
          "remote-storage-mappings": "1.0",
          "remote-storage-extended-mappings": "1.0",
          "remote-storage-providers": "1.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fremote-storage",
        "getModule": function anonymous(
) {
return require('@folio/remote-storage').default;
},
        "description": "Description for remote storage",
        "version": "6.0.0"
      },
      {
        "displayName": "ui-serials-management.meta.title",
        "route": "\u002Fserials-management",
        "home": "\u002Fserials-management\u002Fserials",
        "queryResource": "query",
        "okapiInterfaces": {
          "serials-management": "1.0"
        },
        "optionalOkapiInterfaces": {
          "orders": "12.1",
          "order-lines": "3.0",
          "organizations": "2.0",
          "material-types": "2.2",
          "pieces": "3.0",
          "acquisitions-units": "1.1",
          "holdings-storage": "6.0 7.0 8.0",
          "locations": "3.0",
          "titles": "1.2",
          "identifier-types": "1.2"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components",
          "@k-int\u002Fstripes-kint-components"
        ],
        "module": "@folio\u002Fserials-management",
        "getModule": function anonymous(
) {
return require('@folio/serials-management').default;
},
        "description": "FOLIO app for serials-management",
        "version": "1.1.2"
      },
      {
        "displayName": "ui-service-interaction.meta.title",
        "route": "\u002Fservice-interaction",
        "home": "\u002Fservice-interaction",
        "queryResource": "query",
        "okapiInterfaces": {
          "servint": "4.0"
        },
        "module": "@folio\u002Fservice-interaction",
        "getModule": function anonymous(
) {
return require('@folio/service-interaction').default;
},
        "description": "FOLIO app for service-interaction",
        "version": "3.1.1"
      },
      {
        "displayName": "ui-tags.meta.title",
        "route": "\u002Ftags",
        "queryResource": "query",
        "okapiInterfaces": {
          "tags": "1.0"
        },
        "module": "@folio\u002Ftags",
        "getModule": function anonymous(
) {
return require('@folio/tags').default;
},
        "description": "Tags manager",
        "version": "8.2.1"
      },
      {
        "displayName": "ui-task-list.meta.title.tasks",
        "moduleName": "Tasks",
        "route": "\u002Ftasks",
        "home": "\u002Ftasks",
        "queryResource": "query",
        "okapiInterfaces": {
          "tasks": "1.0",
          "users": "15.0 16.0"
        },
        "module": "@folio-eis\u002Ftask-list",
        "getModule": function anonymous(
) {
return require('@folio-eis/task-list').default;
},
        "description": "FOLIO task management app",
        "version": "6.0.0"
      },
      {
        "displayName": "ui-tenant-settings.meta.title",
        "queryResource": "query",
        "route": "\u002Ftenant-settings",
        "okapiInterfaces": {
          "configuration": "2.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "location-units": "2.0",
          "locations": "3.0",
          "login-saml": "2.0",
          "remote-storage-configurations": "1.0",
          "remote-storage-mappings": "1.0 2.0",
          "service-points": "3.0",
          "reading-room": "1.0"
        },
        "module": "@folio\u002Ftenant-settings",
        "getModule": function anonymous(
) {
return require('@folio/tenant-settings').default;
},
        "description": "Tenant settings",
        "version": "9.0.0"
      },
      {
        "displayName": "ui-users.meta.title",
        "route": "\u002Fusers",
        "home": "\u002Fusers?sort=name",
        "queryResource": "query",
        "actionNames": [
          "stripesHome",
          "usersSortByName"
        ],
        "okapiInterfaces": {
          "users": "16.3",
          "configuration": "2.0",
          "permissions": "5.7",
          "login": "7.3",
          "users-bl": "6.1",
          "staging-users": "1.0",
          "tags": "1.0"
        },
        "optionalOkapiInterfaces": {
          "actual-cost-record-storage": "0.4",
          "add-info": "0.1",
          "automated-patron-blocks": "0.1",
          "batch-print": "1.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "consortia": "1.0",
          "feesfines": "19.1",
          "loan-policy-storage": "1.0 2.0",
          "loan-storage": "4.0 5.0 6.0 7.0",
          "notes": "4.0",
          "request-storage": "2.5 3.0 4.0 5.0 6.0",
          "reading-room-patron-permission": "1.0",
          "roles": "1.0",
          "circulation-bff-loans": "1.3",
          "users-keycloak": "1.0"
        },
        "module": "@folio\u002Fusers",
        "getModule": function anonymous(
) {
return require('@folio/users').default;
},
        "description": "User management",
        "version": "11.0.13"
      }
    ],
    "handler": [
      {
        "handlerName": "eventHandler",
        "displayName": "ui-agreements.meta.title",
        "route": "\u002Ferm",
        "home": "\u002Ferm\u002Fagreements",
        "queryResource": "query",
        "okapiInterfaces": {
          "configuration": "2.0 3.0 4.0 5.0",
          "erm": "7.0",
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "order-lines": "2.0 3.0",
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Fagreements",
        "getModule": function anonymous(
) {
return require('@folio/agreements').default;
},
        "description": "ERM agreement functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-dashboard.meta.title",
        "route": "\u002Fdashboard",
        "home": "\u002Fdashboard",
        "queryResource": "query",
        "okapiInterfaces": {
          "servint": "4.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components",
          "@k-int\u002Fstripes-kint-components"
        ],
        "module": "@folio\u002Fdashboard",
        "getModule": function anonymous(
) {
return require('@folio/dashboard').default;
},
        "description": "Dashboard app for configurable FOLIO widgets",
        "version": "6.1.1"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-handler-stripes-registry.meta.title",
        "module": "@folio\u002Fhandler-stripes-registry",
        "getModule": function anonymous(
) {
return require('@folio/handler-stripes-registry').default;
},
        "description": "frontend registry for Stripes",
        "version": "2.3.0"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-inventory.meta.title",
        "route": "\u002Finventory",
        "home": "\u002Finventory?filters=staffSuppress.false",
        "queryResource": "query",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-inventory-components",
          "@folio\u002Fstripes-marc-components"
        ],
        "okapiInterfaces": {
          "alternative-title-types": "1.0",
          "call-number-types": "1.0",
          "browse": "0.6 1.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0",
          "classification-types": "1.1",
          "configuration": "2.0",
          "contributor-name-types": "1.2",
          "contributor-types": "2.0",
          "data-export": "5.0",
          "data-import-converter-storage": "1.3 1.4 1.5",
          "electronic-access-relationships": "1.0",
          "holdings-note-types": "1.0",
          "holdings-sources": "1.0",
          "holdings-storage": "3.0 4.4 5.0 6.0 7.0 8.0",
          "holdings-types": "1.0",
          "identifier-types": "1.1",
          "ill-policies": "1.0",
          "instance-formats": "2.0",
          "instance-note-types": "1.0",
          "instance-relationship-types": "1.0",
          "instance-statuses": "1.0",
          "instance-storage": "7.0 8.0 9.0 10.0 11.0",
          "instance-types": "2.0",
          "inventory-record-bulk": "1.0",
          "inventory": "10.10 11.0 12.0 13.0 14.0",
          "item-note-types": "1.0",
          "item-storage": "8.0 9.0 10.0",
          "loan-types": "2.0",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.0",
          "modes-of-issuance": "1.0",
          "nature-of-content-terms": "1.0",
          "search": "0.7 1.0 1.3",
          "source-storage-records": "3.3",
          "statistical-code-types": "1.0",
          "statistical-codes": "1.0",
          "tags": "1.0",
          "users": "15.0 16.0"
        },
        "optionalOkapiInterfaces": {
          "consortia": "1.0",
          "copycat-imports": "1.1",
          "copycat-profiles": "1.2",
          "remote-storage-mappings": "1.0 2.0",
          "acquisitions-units": "1.1",
          "orders": "11.0 12.0",
          "orders.holding-summary": "1.0",
          "order-lines": "2.0 3.0",
          "orders-storage.settings": "1.0",
          "organizations.organizations": "1.0",
          "pieces": "3.0",
          "titles": "1.2",
          "browse": "1.5"
        },
        "module": "@folio\u002Finventory",
        "getModule": function anonymous(
) {
return require('@folio/inventory').default;
},
        "description": "Inventory manager",
        "version": "12.0.16"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-licenses.meta.title",
        "route": "\u002Flicenses",
        "home": "\u002Flicenses",
        "queryResource": "query",
        "okapiInterfaces": {
          "licenses": "6.0"
        },
        "optionalOkapiInterfaces": {
          "organizations-storage.interfaces": "2.0",
          "users": "13.0 14.0 15.0 16.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Flicenses",
        "getModule": function anonymous(
) {
return require('@folio/licenses').default;
},
        "description": "ERM License functionality for Stripes",
        "version": "11.1.1"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-servicepoints.meta.title",
        "route": "\u002F",
        "links": {
          "userDropdown": [
            {
              "event": "CHANGE_SERVICE_POINT",
              "caption": "ui-servicepoints.userDropdown.switchServicePoint",
              "check": "checkServicePoints"
            }
          ]
        },
        "module": "@folio\u002Fservicepoints",
        "getModule": function anonymous(
) {
return require('@folio/servicepoints').default;
},
        "description": "Service Points handler for Stripes",
        "version": "7.2.0"
      },
      {
        "handlerName": "eventHandler",
        "displayName": "ui-lists.meta.title",
        "route": "\u002Flists",
        "home": "\u002Flists",
        "okapiInterfaces": {
          "lists": "1.0",
          "fqm-query": "2.0",
          "entity-types": "2.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Flists",
        "getModule": function anonymous(
) {
return require('@folio/lists').default;
},
        "description": "FOLIO Reporting Machine Lists",
        "version": "3.1.6"
      }
    ],
    "plugin": [
      {
        "pluginType": "bursar-export",
        "displayName": "ui-plugin-bursar-export.meta.title",
        "okapiInterfaces": {
          "users": "15.0 16.0",
          "feesfines": "16.0 17.0 18.0 19.0",
          "data-export-spring": "2.0",
          "service-points": "3.0",
          "location-units": "2.0",
          "locations": "3.0"
        },
        "module": "@folio\u002Fplugin-bursar-export",
        "getModule": function anonymous(
) {
return require('@folio/plugin-bursar-export').default;
},
        "description": "Bursar export",
        "version": "4.0.3"
      },
      {
        "pluginType": "create-inventory-records",
        "displayName": "ui-plugin-create-inventory-records.meta.title",
        "okapiInterfaces": {
          "inventory": "10.0 11.0 12.0 13.0 14.0",
          "source-storage-records": "2.0 3.0",
          "instance-storage": "7.0 8.0 9.0 10.0 11.0",
          "holdings-storage": "3.0 4.0 5.0 6.0 7.0 8.0",
          "item-storage": "8.0 9.0 10.0",
          "loan-types": "2.0",
          "material-types": "2.0",
          "item-note-types": "1.0",
          "locations": "3.0",
          "identifier-types": "1.1",
          "contributor-types": "2.0",
          "contributor-name-types": "1.2",
          "instance-types": "2.0",
          "nature-of-content-terms": "1.0",
          "instance-formats": "2.0",
          "classification-types": "1.1",
          "statistical-code-types": "1.0",
          "statistical-codes": "1.0",
          "modes-of-issuance": "1.0",
          "instance-statuses": "1.0",
          "instance-relationship-types": "1.0",
          "instance-note-types": "1.0",
          "alternative-title-types": "1.0",
          "holdings-types": "1.0",
          "call-number-types": "1.0",
          "electronic-access-relationships": "1.0",
          "ill-policies": "1.0",
          "holdings-note-types": "1.0",
          "users": "15.0 16.0",
          "location-units": "2.0",
          "circulation": "9.0 10.0 11.0 12.0 13.0 14.0"
        },
        "module": "@folio\u002Fplugin-create-inventory-records",
        "getModule": function anonymous(
) {
return require('@folio/plugin-create-inventory-records').default;
},
        "description": "Create inventory records for Stripes",
        "version": "5.0.1"
      },
      {
        "pluginType": "find-agreement",
        "displayName": "ui-plugin-find-agreement.meta.title",
        "okapiInterfaces": {
          "erm": "7.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Fplugin-find-agreement",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-agreement').default;
},
        "description": "ERM-agreement-finder for Stripes",
        "version": "11.1.0"
      },
      {
        "stripesDeps": [
          "@folio\u002Fstripes-authority-components"
        ],
        "pluginType": "find-authority",
        "displayName": "ui-plugin-find-authority.meta.title",
        "queryResource": "query",
        "module": "@folio\u002Fplugin-find-authority",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-authority').default;
},
        "description": "Stripes plugin to find authorities",
        "version": "4.1.0"
      },
      {
        "pluginType": "find-contact",
        "okapiInterfaces": {
          "organizations-storage.categories": "1.1",
          "organizations-storage.contacts": "2.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "displayName": "ui-plugin-find-contact.meta.pluginTitle",
        "module": "@folio\u002Fplugin-find-contact",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-contact').default;
},
        "description": "Find and select contacts plugin for Stripes",
        "version": "5.2.0"
      },
      {
        "pluginType": "find-eresource",
        "displayName": "ui-plugin-find-eresource.meta.title",
        "okapiInterfaces": {
          "erm": "7.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components",
          "@k-int\u002Fstripes-kint-components"
        ],
        "module": "@folio\u002Fplugin-find-eresource",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-eresource').default;
},
        "description": "ERM-eresource-finder for Stripes",
        "version": "7.1.0"
      },
      {
        "pluginType": "find-fund",
        "displayName": "ui-plugin-find-fund.meta.title",
        "okapiInterfaces": {},
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fplugin-find-fund",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-fund').default;
},
        "description": "Find and select funds plugin for Stripes",
        "version": "3.2.0"
      },
      {
        "pluginType": "find-import-profile",
        "displayName": "ui-plugin-find-import-profile.meta.pluginTitle",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components",
          "@folio\u002Fstripes-data-transfer-components"
        ],
        "okapiInterfaces": {
          "data-import": "3.2",
          "source-manager-job-executions": "3.4",
          "data-import-converter-storage": "1.5"
        },
        "module": "@folio\u002Fplugin-find-import-profile",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-import-profile').default;
},
        "description": "Find and select Data Import Profiles plugin for Stripes",
        "version": "8.0.0"
      },
      {
        "pluginType": "find-instance",
        "displayName": "ui-plugin-find-instance.meta.title",
        "okapiInterfaces": {
          "contributor-types": "2.0",
          "instance-types": "2.0",
          "locations": "3.0",
          "search": "0.5 1.0"
        },
        "module": "@folio\u002Fplugin-find-instance",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-instance').default;
},
        "description": "Instance-finder for Stripes",
        "version": "8.0.1"
      },
      {
        "pluginType": "find-interface",
        "okapiInterfaces": {
          "organizations-storage.interfaces": "2.1"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "displayName": "ui-plugin-find-interface.meta.title",
        "module": "@folio\u002Fplugin-find-interface",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-interface').default;
},
        "description": "Find and select interfaces plugin for Stripes",
        "version": "5.2.0"
      },
      {
        "pluginType": "find-license",
        "displayName": "ui-plugin-find-license.meta.title",
        "okapiInterfaces": {
          "licenses": "6.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-erm-components"
        ],
        "module": "@folio\u002Fplugin-find-license",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-license').default;
},
        "description": "License-finder for Stripes",
        "version": "11.1.0"
      },
      {
        "pluginType": "find-organization",
        "okapiInterfaces": {
          "configuration": "2.0",
          "organizations.organizations": "1.0",
          "tags": "1.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "displayName": "ui-plugin-find-organization.meta.pluginTitle",
        "module": "@folio\u002Fplugin-find-organization",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-organization').default;
},
        "description": "Organization-finder for Stripes",
        "version": "5.2.0"
      },
      {
        "pluginType": "find-package-title",
        "displayName": "ui-plugin-find-package-title.meta.title",
        "queryResource": "query",
        "module": "@folio\u002Fplugin-find-package-title",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-package-title').default;
},
        "description": "Stripes plugin to find packages and titles",
        "version": "6.2.0"
      },
      {
        "pluginType": "find-po-line",
        "displayName": "ui-plugin-find-po-line.meta.title",
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "okapiInterfaces": {
          "acquisition-methods": "1.0",
          "acquisitions-units": "1.1",
          "configuration.prefixes": "1.1",
          "configuration.reasons-for-closure": "1.0",
          "configuration.suffixes": "1.1",
          "contributor-name-types": "1.2",
          "finance.expense-classes": "2.0 3.0",
          "finance.funds": "1.4 2.0 3.0",
          "identifier-types": "1.2",
          "inventory": "10.0 11.0 12.0 13.0 14.0",
          "location-units": "2.0",
          "locations": "3.0",
          "material-types": "2.2",
          "order-lines": "2.0 3.0",
          "organizations.organizations": "1.0",
          "tags": "1.0"
        },
        "module": "@folio\u002Fplugin-find-po-line",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-po-line').default;
},
        "description": "Find and select PO lines plugin for Stripes",
        "version": "5.2.0"
      },
      {
        "pluginType": "query-builder",
        "displayName": "ui-plugin-query-builder.meta.title",
        "okapiInterfaces": {
          "fqm-query": "2.0",
          "configuration": "2.0"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fplugin-query-builder",
        "getModule": function anonymous(
) {
return require('@folio/plugin-query-builder').default;
},
        "description": "Create FQL query plugin for Stripes",
        "version": "1.2.10"
      },
      {
        "pluginType": "find-user",
        "displayName": "ui-plugin-find-user.meta.title",
        "queryResource": "query",
        "module": "@folio\u002Fplugin-find-user",
        "getModule": function anonymous(
) {
return require('@folio/plugin-find-user').default;
},
        "description": "User-finder for Stripes",
        "version": "7.2.0"
      },
      {
        "pluginType": "quick-marc",
        "displayName": "ui-quick-marc.meta.title",
        "okapiInterfaces": {
          "inventory": "14.0",
          "marc-records-editor": "6.0",
          "search": "1.2",
          "marc-specifications": "1.0",
          "authority-source-files": "2.0",
          "instance-authority-links": "2.1"
        },
        "stripesDeps": [
          "@folio\u002Fstripes-acq-components"
        ],
        "module": "@folio\u002Fquick-marc",
        "getModule": function anonymous(
) {
return require('@folio/quick-marc').default;
},
        "description": "Quick MARC editor",
        "version": "9.0.1"
      }
    ],
    "": [
      {
        "module": "@folio\u002Fstripes-acq-components",
        "getModule": function anonymous(
) {
return require('@folio/stripes-acq-components').default;
},
        "description": "Component library for Stripes Acquisitions modules",
        "version": "6.0.5"
      },
      {
        "okapiInterfaces": {
          "search": "1.0",
          "browse": "1.0",
          "authority-source-files": "2.0",
          "source-storage-records": "3.0"
        },
        "module": "@folio\u002Fstripes-authority-components",
        "getModule": function anonymous(
) {
return require('@folio/stripes-authority-components').default;
},
        "description": "Component library for Stripes Authority modules",
        "version": "5.0.3"
      },
      {
        "module": "@folio\u002Fstripes-erm-components",
        "getModule": function anonymous(
) {
return require('@folio/stripes-erm-components').default;
},
        "description": "Component library for Stripes ERM applications",
        "version": "9.2.0"
      },
      {
        "okapiInterfaces": {
          "instance-authority-linking-rules": "1.1"
        },
        "module": "@folio\u002Fstripes-marc-components",
        "getModule": function anonymous(
) {
return require('@folio/stripes-marc-components').default;
},
        "description": "Component library for Stripes Marc modules",
        "version": "1.1.0"
      }
    ]
  }
};
      const branding = {
  "logo": {
    "src": require('../logo.png'),
    "alt": "Tenant logo"
  },
  "favicon": {
    "src": require('../favicon.png')
  }
};
      const errorLogging = {};
      const translations = {
  "ar": "\u002F20250709-080403\u002Ftranslations\u002Far-1752048250882.json",
  "ber": "\u002F20250709-080403\u002Ftranslations\u002Fber-1752048250882.json",
  "ca": "\u002F20250709-080403\u002Ftranslations\u002Fca-1752048250882.json",
  "cs_CZ": "\u002F20250709-080403\u002Ftranslations\u002Fcs_CZ-1752048250882.json",
  "da": "\u002F20250709-080403\u002Ftranslations\u002Fda-1752048250882.json",
  "de": "\u002F20250709-080403\u002Ftranslations\u002Fde-1752048250882.json",
  "en": "\u002F20250709-080403\u002Ftranslations\u002Fen-1752048250882.json",
  "en_GB": "\u002F20250709-080403\u002Ftranslations\u002Fen_GB-1752048250882.json",
  "en_SE": "\u002F20250709-080403\u002Ftranslations\u002Fen_SE-1752048250882.json",
  "en_US": "\u002F20250709-080403\u002Ftranslations\u002Fen_US-1752048250882.json",
  "es": "\u002F20250709-080403\u002Ftranslations\u002Fes-1752048250882.json",
  "es_419": "\u002F20250709-080403\u002Ftranslations\u002Fes_419-1752048250882.json",
  "es_ES": "\u002F20250709-080403\u002Ftranslations\u002Fes_ES-1752048250882.json",
  "fr": "\u002F20250709-080403\u002Ftranslations\u002Ffr-1752048250882.json",
  "fr_FR": "\u002F20250709-080403\u002Ftranslations\u002Ffr_FR-1752048250882.json",
  "he": "\u002F20250709-080403\u002Ftranslations\u002Fhe-1752048250882.json",
  "hi_IN": "\u002F20250709-080403\u002Ftranslations\u002Fhi_IN-1752048250882.json",
  "hu": "\u002F20250709-080403\u002Ftranslations\u002Fhu-1752048250882.json",
  "it_IT": "\u002F20250709-080403\u002Ftranslations\u002Fit_IT-1752048250882.json",
  "ja": "\u002F20250709-080403\u002Ftranslations\u002Fja-1752048250882.json",
  "ko": "\u002F20250709-080403\u002Ftranslations\u002Fko-1752048250882.json",
  "nb": "\u002F20250709-080403\u002Ftranslations\u002Fnb-1752048250882.json",
  "nl": "\u002F20250709-080403\u002Ftranslations\u002Fnl-1752048250882.json",
  "nn": "\u002F20250709-080403\u002Ftranslations\u002Fnn-1752048250882.json",
  "pl": "\u002F20250709-080403\u002Ftranslations\u002Fpl-1752048250882.json",
  "pt_BR": "\u002F20250709-080403\u002Ftranslations\u002Fpt_BR-1752048250882.json",
  "pt_PT": "\u002F20250709-080403\u002Ftranslations\u002Fpt_PT-1752048250882.json",
  "ru": "\u002F20250709-080403\u002Ftranslations\u002Fru-1752048250882.json",
  "sk": "\u002F20250709-080403\u002Ftranslations\u002Fsk-1752048250882.json",
  "sv": "\u002F20250709-080403\u002Ftranslations\u002Fsv-1752048250882.json",
  "ur": "\u002F20250709-080403\u002Ftranslations\u002Fur-1752048250882.json",
  "zh_CN": "\u002F20250709-080403\u002Ftranslations\u002Fzh_CN-1752048250882.json",
  "zh_TW": "\u002F20250709-080403\u002Ftranslations\u002Fzh_TW-1752048250882.json",
  "uk": "\u002F20250709-080403\u002Ftranslations\u002Fuk-1752048250882.json",
  "zu": "\u002F20250709-080403\u002Ftranslations\u002Fzu-1752048250882.json"
};
      const metadata = {
  "acquisition-units": {
    "name": "acquisition-units",
    "version": "5.2.0",
    "description": "Acquisition units",
    "license": "Apache-2.0",
    "shortTitle": "ui-acquisition-units.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage Acquisition units",
        "title": "Acquisition units",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "agreements": {
    "name": "agreements",
    "version": "11.1.1",
    "description": "ERM agreement functionality for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-agreements.meta.title",
    "icons": {
      "app": {
        "alt": "ERM agreement functionality for Stripes",
        "title": "Agreements",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.png')
        }
      },
      "agreementLine": {
        "alt": " ",
        "title": "Agreement line",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.png')
        }
      },
      "closedAgreement": {
        "alt": " ",
        "title": "Closed agreement",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.png')
        }
      },
      "eresource": {
        "alt": " ",
        "title": "eresource",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.png')
        }
      },
      "package": {
        "alt": " ",
        "title": "Package",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.png')
        }
      },
      "pci": {
        "alt": " ",
        "title": "PCI",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.png')
        }
      },
      "title": {
        "alt": " ",
        "title": "Title",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.png')
        }
      },
      "platform": {
        "alt": " ",
        "title": "platform",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.png')
        }
      },
      "printTitle": {
        "alt": " ",
        "title": "Print title",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "bulk-edit": {
    "name": "bulk-edit",
    "version": "4.2.4",
    "description": "Description for bulk edit",
    "license": "Apache-2.0",
    "shortTitle": "ui-bulk-edit.meta.title",
    "icons": {
      "app": {
        "alt": "View and manage bulk edit",
        "title": "Bulk edit",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "calendar": {
    "name": "calendar",
    "version": "11.0.3",
    "description": "Calendar settings",
    "license": "Apache-2.0",
    "shortTitle": "ui-calendar.meta.title",
    "icons": {
      "app": {
        "alt": "Service Point Opening Calendar",
        "title": "Calendar",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "checkin": {
    "name": "checkin",
    "version": "10.0.2",
    "description": "Item Check-in",
    "license": "Apache-2.0",
    "shortTitle": "ui-checkin.meta.title",
    "icons": {
      "app": {
        "alt": "Check in items",
        "title": "Checkout",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "checkout": {
    "name": "checkout",
    "version": "11.0.3",
    "description": "Item Check-out",
    "license": "Apache-2.0",
    "shortTitle": "ui-checkout.meta.title",
    "icons": {
      "app": {
        "alt": "Check out items on behalf of patrons",
        "title": "Checkout",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "circulation": {
    "name": "circulation",
    "version": "10.0.1",
    "description": "Circulation manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-circulation.meta.title",
    "icons": {
      "app": {
        "alt": "Create and manage loan policies",
        "title": "Circulation",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "circulation-log": {
    "name": "circulation-log",
    "version": "5.0.1",
    "description": "Description for circulation logs",
    "license": "Apache-2.0",
    "shortTitle": "ui-circulation-log.meta.title",
    "icons": {
      "app": {
        "alt": "View and manage circulation logs",
        "title": "Circulation logs",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "courses": {
    "name": "courses",
    "version": "6.1.2",
    "description": "Maintain courses and reserve items for them",
    "license": "Apache-2.0",
    "shortTitle": "ui-courses.meta.title",
    "icons": {
      "app": {
        "alt": "Maintain courses and reserve items for them",
        "title": "Courses",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "dashboard": {
    "name": "dashboard",
    "version": "6.1.1",
    "description": "Dashboard app for configurable FOLIO widgets",
    "license": "Apache-2.0",
    "shortTitle": "ui-dashboard.meta.title",
    "icons": {
      "app": {
        "alt": "Dashboard app for configurable FOLIO widgets",
        "title": "Dashboard",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "data-export": {
    "name": "data-export",
    "version": "6.2.0",
    "description": "Data export manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-data-export.meta.title",
    "icons": {
      "app": {
        "alt": "Data export loader for MARC records",
        "title": "Data export",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "data-import": {
    "name": "data-import",
    "version": "8.0.5",
    "description": "Data Import manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-data-import.meta.title",
    "icons": {
      "holdings": {
        "alt": "eHoldings",
        "title": "eHoldings",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.png')
        }
      },
      "orders": {
        "alt": "Orders",
        "title": "Orders",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.png')
        }
      },
      "invoices": {
        "alt": "Invoices",
        "title": "Invoices",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.png')
        }
      },
      "instances": {
        "alt": "Instances",
        "title": "Instances",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.png')
        }
      },
      "items": {
        "alt": "Items",
        "title": "Items",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.png')
        }
      },
      "jobProfiles": {
        "alt": "Job Profiles",
        "title": "Job Profiles",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.png')
        }
      },
      "marcAuthorities": {
        "alt": "MARC authorities",
        "title": "MARC authorities",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.png')
        }
      },
      "marcBibs": {
        "alt": "MARC bibliographics",
        "title": "MARC bibliographics",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.png')
        }
      },
      "marcHoldings": {
        "alt": "MARC holdings",
        "title": "MARC holdings",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.png')
        }
      },
      "matchProfiles": {
        "alt": "Match Profiles",
        "title": "Match Profiles",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.png')
        }
      },
      "actionProfiles": {
        "alt": "Action Profiles",
        "title": "Action Profiles",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.png')
        }
      },
      "mappingProfiles": {
        "alt": "Field Mapping Profiles",
        "title": "Field Mapping Profiles",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.png')
        }
      },
      "app": {
        "alt": "Data import loader for MARC records",
        "title": "Data import",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.png')
        }
      },
      "user": {
        "alt": "User",
        "title": "User",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "developer": {
    "name": "developer",
    "version": "9.0.0",
    "description": "Developer settings",
    "license": "Apache-2.0",
    "shortTitle": "ui-developer.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "eholdings": {
    "name": "eholdings",
    "version": "10.0.1",
    "description": "FOLIO UI module for eHoldings",
    "license": "Apache-2.0",
    "shortTitle": "ui-eholdings.meta.title",
    "icons": {
      "app": {
        "alt": "FOLIO UI module for eHoldings",
        "title": "eHoldings",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.png')
        }
      },
      "selectedPackage": {
        "alt": "Selected",
        "title": "Selected",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "export-manager": {
    "name": "export-manager",
    "version": "3.2.0",
    "description": "Description for export manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-export-manager.meta.title",
    "icons": {
      "app": {
        "alt": "View export manager",
        "title": "Export manager",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "finance": {
    "name": "finance",
    "version": "7.0.1",
    "description": "Description for ui-finance",
    "license": "Apache-2.0",
    "shortTitle": "ui-finance.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage Finance",
        "title": "Finance",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "gobi-settings": {
    "name": "gobi-settings",
    "version": "3.2.0",
    "description": "GOBI integration settings",
    "license": "Apache-2.0",
    "shortTitle": "ui-gobi-settings.meta.title",
    "icons": {
      "app": {
        "alt": "GOBI integration",
        "title": "GOBI integration",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "handler-stripes-registry": {
    "name": "handler-stripes-registry",
    "version": "2.3.0",
    "description": "frontend registry for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-handler-stripes-registry.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "inventory": {
    "name": "inventory",
    "version": "12.0.16",
    "description": "Inventory manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-inventory.meta.title",
    "icons": {
      "app": {
        "alt": "View and manage instance records, holdings records and item records",
        "title": "Inventory",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.png')
        }
      },
      "bound-with": {
        "alt": "Bound with one or more instances or holdings",
        "title": "Bound-with",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.png')
        }
      },
      "holdings": {
        "alt": "",
        "title": "Holding",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.png')
        }
      },
      "item": {
        "alt": "",
        "title": "Item",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.png')
        }
      },
      "instance": {
        "alt": "",
        "title": "Instance",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "invoice": {
    "name": "invoice",
    "version": "6.1.3",
    "description": "Invoice",
    "license": "Apache-2.0",
    "shortTitle": "ui-invoice.meta.title",
    "icons": {
      "app": {
        "alt": "Manage invoices",
        "title": "Invoice",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "licenses": {
    "name": "licenses",
    "version": "11.1.1",
    "description": "ERM License functionality for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-licenses.meta.title",
    "icons": {
      "app": {
        "alt": "ERM license functionality for Stripes",
        "title": "Licenses",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.png')
        }
      },
      "inactiveLicense": {
        "alt": " ",
        "title": "Inactive license",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.png')
        }
      },
      "amendment": {
        "alt": " ",
        "title": "Amendment",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "marc-authorities": {
    "name": "marc-authorities",
    "version": "6.0.1",
    "description": "MARC Authorities module",
    "license": "Apache-2.0",
    "shortTitle": "ui-marc-authorities.meta.title",
    "icons": {
      "app": {
        "alt": "MARC Authorities module",
        "title": "MARC Authorities",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "myprofile": {
    "name": "myprofile",
    "version": "9.2.0",
    "description": "My profile",
    "license": "Apache-2.0",
    "shortTitle": "ui-myprofile.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "notes": {
    "name": "notes",
    "version": "10.0.0",
    "description": "Note types manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-notes.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "oai-pmh": {
    "name": "oai-pmh",
    "version": "5.2.0",
    "description": "OAI-PMH manager",
    "license": "Apache-2.0",
    "type": "settings",
    "shortTitle": "ui-oai-pmh.meta.title",
    "icons": {
      "app": {
        "alt": "OAI-PMH manager",
        "title": "OAI-PMH manager",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "orders": {
    "name": "orders",
    "version": "7.0.5",
    "description": "Description for orders",
    "license": "Apache-2.0",
    "shortTitle": "ui-orders.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage orders",
        "title": "Orders",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "organizations": {
    "name": "organizations",
    "version": "5.2.0",
    "description": "Organizations",
    "license": "Apache-2.0",
    "shortTitle": "ui-organizations.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage organizations",
        "title": "Organizations",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "plugin-bursar-export": {
    "name": "plugin-bursar-export",
    "version": "4.0.3",
    "description": "Bursar export",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-bursar-export.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-create-inventory-records": {
    "name": "plugin-create-inventory-records",
    "version": "5.0.1",
    "description": "Create inventory records for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-create-inventory-records.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-agreement": {
    "name": "plugin-find-agreement",
    "version": "11.1.0",
    "description": "ERM-agreement-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-agreement.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-authority": {
    "name": "plugin-find-authority",
    "version": "4.1.0",
    "description": "Stripes plugin to find authorities",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-authority.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-contact": {
    "name": "plugin-find-contact",
    "version": "5.2.0",
    "description": "Find and select contacts plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-contact.meta.pluginTitle",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-eresource": {
    "name": "plugin-find-eresource",
    "version": "7.1.0",
    "description": "ERM-eresource-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-eresource.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-fund": {
    "name": "plugin-find-fund",
    "version": "3.2.0",
    "description": "Find and select funds plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-fund.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-import-profile": {
    "name": "plugin-find-import-profile",
    "version": "8.0.0",
    "description": "Find and select Data Import Profiles plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-import-profile.meta.pluginTitle",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-instance": {
    "name": "plugin-find-instance",
    "version": "8.0.1",
    "description": "Instance-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-instance.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-interface": {
    "name": "plugin-find-interface",
    "version": "5.2.0",
    "description": "Find and select interfaces plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-interface.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-license": {
    "name": "plugin-find-license",
    "version": "11.1.0",
    "description": "License-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-license.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-organization": {
    "name": "plugin-find-organization",
    "version": "5.2.0",
    "description": "Organization-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-organization.meta.pluginTitle",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-package-title": {
    "name": "plugin-find-package-title",
    "version": "6.2.0",
    "description": "Stripes plugin to find packages and titles",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-package-title.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-po-line": {
    "name": "plugin-find-po-line",
    "version": "5.2.0",
    "description": "Find and select PO lines plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-po-line.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-query-builder": {
    "name": "plugin-query-builder",
    "version": "1.2.10",
    "description": "Create FQL query plugin for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-query-builder.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "plugin-find-user": {
    "name": "plugin-find-user",
    "version": "7.2.0",
    "description": "User-finder for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-plugin-find-user.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "quick-marc": {
    "name": "quick-marc",
    "version": "9.0.1",
    "description": "Quick MARC editor",
    "license": "Apache-2.0",
    "shortTitle": "ui-quick-marc.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "reading-room": {
    "name": "reading-room",
    "version": "1.1.1",
    "description": "Reading Room Access",
    "license": "Apache-2.0",
    "shortTitle": "ui-reading-room.meta.title",
    "icons": {
      "app": {
        "alt": "Allow/deny patrons to access reading room",
        "title": "Reading room",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "receiving": {
    "name": "receiving",
    "version": "6.0.6",
    "description": "Description for receiving",
    "license": "Apache-2.0",
    "shortTitle": "ui-receiving.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage receiving",
        "title": "receiving",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "remote-storage": {
    "name": "remote-storage",
    "version": "6.0.0",
    "description": "Description for remote storage",
    "license": "Apache-2.0",
    "shortTitle": "ui-remote-storage.meta.title",
    "icons": {
      "app": {
        "alt": "View and manage remote storages",
        "title": "Remote storage",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "requests": {
    "name": "requests",
    "version": "11.0.9",
    "description": "Requests manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-requests.meta.title",
    "icons": {
      "app": {
        "alt": "Requests",
        "title": "Requests manager",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "serials-management": {
    "name": "serials-management",
    "version": "1.1.2",
    "description": "FOLIO app for serials-management",
    "license": "Apache-2.0",
    "shortTitle": "ui-serials-management.meta.title",
    "icons": {
      "app": {
        "alt": "FOLIO app for Serials Management",
        "title": "serials",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "service-interaction": {
    "name": "service-interaction",
    "version": "3.1.1",
    "description": "FOLIO app for service-interaction",
    "license": "Apache-2.0",
    "shortTitle": "ui-service-interaction.meta.title",
    "icons": {
      "app": {
        "alt": "FOLIO app for service-interaction",
        "title": "Service interaction",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "servicepoints": {
    "name": "servicepoints",
    "version": "7.2.0",
    "description": "Service Points handler for Stripes",
    "license": "Apache-2.0",
    "shortTitle": "ui-servicepoints.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "stripes-acq-components": {
    "name": "stripes-acq-components",
    "version": "6.0.5",
    "description": "Component library for Stripes Acquisitions modules",
    "license": "Apache-2.0",
    "icons": {},
    "welcomePageEntries": []
  },
  "stripes-authority-components": {
    "name": "stripes-authority-components",
    "version": "5.0.3",
    "description": "Component library for Stripes Authority modules",
    "license": "Apache-2.0",
    "icons": {},
    "welcomePageEntries": []
  },
  "stripes-erm-components": {
    "name": "stripes-erm-components",
    "version": "9.2.0",
    "description": "Component library for Stripes ERM applications",
    "license": "Apache-2.0",
    "icons": {},
    "welcomePageEntries": []
  },
  "stripes-marc-components": {
    "name": "stripes-marc-components",
    "version": "1.1.0",
    "description": "Component library for Stripes Marc modules",
    "license": "Apache-2.0",
    "icons": {},
    "welcomePageEntries": []
  },
  "tags": {
    "name": "tags",
    "version": "8.2.1",
    "description": "Tags manager",
    "license": "Apache-2.0",
    "shortTitle": "ui-tags.meta.title",
    "icons": {
      "app": {
        "alt": "",
        "title": "Tags",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "task-list": {
    "name": "task-list",
    "version": "6.0.0",
    "description": "FOLIO task management app",
    "license": "Apache-2.0",
    "shortTitle": "ui-task-list.meta.title.tasks",
    "icons": {
      "app": {
        "alt": "FOLIO UI module for task list",
        "title": "Task List",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "tenant-settings": {
    "name": "tenant-settings",
    "version": "9.0.0",
    "description": "Tenant settings",
    "license": "Apache-2.0",
    "shortTitle": "ui-tenant-settings.meta.title",
    "icons": {},
    "welcomePageEntries": []
  },
  "users": {
    "name": "users",
    "version": "11.0.13",
    "description": "User management",
    "license": "Apache-2.0",
    "shortTitle": "ui-users.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage users",
        "title": "Users",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  },
  "lists": {
    "name": "lists",
    "version": "3.1.6",
    "description": "FOLIO Reporting Machine Lists",
    "license": "Apache-2.0",
    "shortTitle": "ui-lists.meta.title",
    "icons": {
      "app": {
        "alt": "Create, view and manage lists",
        "title": "Lists",
        "high": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.svg')
        },
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.svg'),
        "low": {
          "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.png')
        }
      }
    },
    "welcomePageEntries": []
  }
};
      const icons = {
  "@folio/acquisition-units": {
    "app": {
      "alt": "Create, view and manage Acquisition units",
      "title": "Acquisition units",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/acquisition-units/icons/app.png')
      }
    }
  },
  "@folio/agreements": {
    "app": {
      "alt": "ERM agreement functionality for Stripes",
      "title": "Agreements",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/app.png')
      }
    },
    "agreementLine": {
      "alt": " ",
      "title": "Agreement line",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/agreementLine.png')
      }
    },
    "closedAgreement": {
      "alt": " ",
      "title": "Closed agreement",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/closedAgreement.png')
      }
    },
    "eresource": {
      "alt": " ",
      "title": "eresource",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/eresource.png')
      }
    },
    "package": {
      "alt": " ",
      "title": "Package",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/package.png')
      }
    },
    "pci": {
      "alt": " ",
      "title": "PCI",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/pci.png')
      }
    },
    "title": {
      "alt": " ",
      "title": "Title",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/title.png')
      }
    },
    "platform": {
      "alt": " ",
      "title": "platform",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/platform.png')
      }
    },
    "printTitle": {
      "alt": " ",
      "title": "Print title",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/agreements/icons/printTitle.png')
      }
    }
  },
  "@folio/bulk-edit": {
    "app": {
      "alt": "View and manage bulk edit",
      "title": "Bulk edit",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/bulk-edit/icons/app.png')
      }
    }
  },
  "@folio/calendar": {
    "app": {
      "alt": "Service Point Opening Calendar",
      "title": "Calendar",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/calendar/icons/app.png')
      }
    }
  },
  "@folio/checkin": {
    "app": {
      "alt": "Check in items",
      "title": "Checkout",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkin/icons/app.png')
      }
    }
  },
  "@folio/checkout": {
    "app": {
      "alt": "Check out items on behalf of patrons",
      "title": "Checkout",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/checkout/icons/app.png')
      }
    }
  },
  "@folio/circulation": {
    "app": {
      "alt": "Create and manage loan policies",
      "title": "Circulation",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation/icons/app.png')
      }
    }
  },
  "@folio/circulation-log": {
    "app": {
      "alt": "View and manage circulation logs",
      "title": "Circulation logs",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/circulation-log/icons/app.png')
      }
    }
  },
  "@folio/courses": {
    "app": {
      "alt": "Maintain courses and reserve items for them",
      "title": "Courses",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/courses/icons/app.png')
      }
    }
  },
  "@folio/dashboard": {
    "app": {
      "alt": "Dashboard app for configurable FOLIO widgets",
      "title": "Dashboard",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/dashboard/icons/app.png')
      }
    }
  },
  "@folio/data-export": {
    "app": {
      "alt": "Data export loader for MARC records",
      "title": "Data export",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-export/icons/app.png')
      }
    }
  },
  "@folio/data-import": {
    "holdings": {
      "alt": "eHoldings",
      "title": "eHoldings",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/holdings.png')
      }
    },
    "orders": {
      "alt": "Orders",
      "title": "Orders",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/orders.png')
      }
    },
    "invoices": {
      "alt": "Invoices",
      "title": "Invoices",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/invoices.png')
      }
    },
    "instances": {
      "alt": "Instances",
      "title": "Instances",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/instances.png')
      }
    },
    "items": {
      "alt": "Items",
      "title": "Items",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/items.png')
      }
    },
    "jobProfiles": {
      "alt": "Job Profiles",
      "title": "Job Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/jobProfiles.png')
      }
    },
    "marcAuthorities": {
      "alt": "MARC authorities",
      "title": "MARC authorities",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcAuthorities.png')
      }
    },
    "marcBibs": {
      "alt": "MARC bibliographics",
      "title": "MARC bibliographics",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcBibs.png')
      }
    },
    "marcHoldings": {
      "alt": "MARC holdings",
      "title": "MARC holdings",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/marcHoldings.png')
      }
    },
    "matchProfiles": {
      "alt": "Match Profiles",
      "title": "Match Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/matchProfiles.png')
      }
    },
    "actionProfiles": {
      "alt": "Action Profiles",
      "title": "Action Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/actionProfiles.png')
      }
    },
    "mappingProfiles": {
      "alt": "Field Mapping Profiles",
      "title": "Field Mapping Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/mappingProfiles.png')
      }
    },
    "app": {
      "alt": "Data import loader for MARC records",
      "title": "Data import",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/app.png')
      }
    },
    "user": {
      "alt": "User",
      "title": "User",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/data-import/icons/user.png')
      }
    }
  },
  "@folio/developer": {},
  "@folio/eholdings": {
    "app": {
      "alt": "FOLIO UI module for eHoldings",
      "title": "eHoldings",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/app.png')
      }
    },
    "selectedPackage": {
      "alt": "Selected",
      "title": "Selected",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/eholdings/icons/selectedPackage.png')
      }
    }
  },
  "@folio/export-manager": {
    "app": {
      "alt": "View export manager",
      "title": "Export manager",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/export-manager/icons/app.png')
      }
    }
  },
  "@folio/finance": {
    "app": {
      "alt": "Create, view and manage Finance",
      "title": "Finance",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/finance/icons/app.png')
      }
    }
  },
  "@folio/gobi-settings": {
    "app": {
      "alt": "GOBI integration",
      "title": "GOBI integration",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/gobi-settings/icons/app.png')
      }
    }
  },
  "@folio/handler-stripes-registry": {},
  "@folio/inventory": {
    "app": {
      "alt": "View and manage instance records, holdings records and item records",
      "title": "Inventory",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/app.png')
      }
    },
    "bound-with": {
      "alt": "Bound with one or more instances or holdings",
      "title": "Bound-with",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/bound-with.png')
      }
    },
    "holdings": {
      "alt": "",
      "title": "Holding",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/holdings.png')
      }
    },
    "item": {
      "alt": "",
      "title": "Item",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/item.png')
      }
    },
    "instance": {
      "alt": "",
      "title": "Instance",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/inventory/icons/instance.png')
      }
    }
  },
  "@folio/invoice": {
    "app": {
      "alt": "Manage invoices",
      "title": "Invoice",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/invoice/icons/app.png')
      }
    }
  },
  "@folio/licenses": {
    "app": {
      "alt": "ERM license functionality for Stripes",
      "title": "Licenses",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/app.png')
      }
    },
    "inactiveLicense": {
      "alt": " ",
      "title": "Inactive license",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/inactiveLicense.png')
      }
    },
    "amendment": {
      "alt": " ",
      "title": "Amendment",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/licenses/icons/amendment.png')
      }
    }
  },
  "@folio/marc-authorities": {
    "app": {
      "alt": "MARC Authorities module",
      "title": "MARC Authorities",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/marc-authorities/icons/app.png')
      }
    }
  },
  "@folio/myprofile": {},
  "@folio/notes": {},
  "@folio/oai-pmh": {
    "app": {
      "alt": "OAI-PMH manager",
      "title": "OAI-PMH manager",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/oai-pmh/icons/app.png')
      }
    }
  },
  "@folio/orders": {
    "app": {
      "alt": "Create, view and manage orders",
      "title": "Orders",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/orders/icons/app.png')
      }
    }
  },
  "@folio/organizations": {
    "app": {
      "alt": "Create, view and manage organizations",
      "title": "Organizations",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/organizations/icons/app.png')
      }
    }
  },
  "@folio/plugin-bursar-export": {},
  "@folio/plugin-create-inventory-records": {},
  "@folio/plugin-find-agreement": {},
  "@folio/plugin-find-authority": {},
  "@folio/plugin-find-contact": {},
  "@folio/plugin-find-eresource": {},
  "@folio/plugin-find-fund": {},
  "@folio/plugin-find-import-profile": {},
  "@folio/plugin-find-instance": {},
  "@folio/plugin-find-interface": {},
  "@folio/plugin-find-license": {},
  "@folio/plugin-find-organization": {},
  "@folio/plugin-find-package-title": {},
  "@folio/plugin-find-po-line": {},
  "@folio/plugin-query-builder": {},
  "@folio/plugin-find-user": {},
  "@folio/quick-marc": {},
  "@folio/reading-room": {
    "app": {
      "alt": "Allow/deny patrons to access reading room",
      "title": "Reading room",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/reading-room/icons/app.png')
      }
    }
  },
  "@folio/receiving": {
    "app": {
      "alt": "Create, view and manage receiving",
      "title": "receiving",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/receiving/icons/app.png')
      }
    }
  },
  "@folio/remote-storage": {
    "app": {
      "alt": "View and manage remote storages",
      "title": "Remote storage",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/remote-storage/icons/app.png')
      }
    }
  },
  "@folio/requests": {
    "app": {
      "alt": "Requests",
      "title": "Requests manager",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/requests/icons/app.png')
      }
    }
  },
  "@folio/serials-management": {
    "app": {
      "alt": "FOLIO app for Serials Management",
      "title": "serials",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/serials-management/icons/app.png')
      }
    }
  },
  "@folio/service-interaction": {
    "app": {
      "alt": "FOLIO app for service-interaction",
      "title": "Service interaction",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/service-interaction/icons/app.png')
      }
    }
  },
  "@folio/servicepoints": {},
  "@folio/stripes-acq-components": {},
  "@folio/stripes-authority-components": {},
  "@folio/stripes-erm-components": {},
  "@folio/stripes-marc-components": {},
  "@folio/tags": {
    "app": {
      "alt": "",
      "title": "Tags",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/tags/icons/app.png')
      }
    }
  },
  "@folio-eis/task-list": {
    "app": {
      "alt": "FOLIO UI module for task list",
      "title": "Task List",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio-eis/task-list/icons/app.png')
      }
    }
  },
  "@folio/tenant-settings": {},
  "@folio/users": {
    "app": {
      "alt": "Create, view and manage users",
      "title": "Users",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/users/icons/app.png')
      }
    }
  },
  "@folio/lists": {
    "app": {
      "alt": "Create, view and manage lists",
      "title": "Lists",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/lists/icons/app.png')
      }
    }
  },
  "@folio/stripes-data-transfer-components": {
    "mappingProfiles": {
      "alt": "Field Mapping Profiles",
      "title": "Field Mapping Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/mappingProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/mappingProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/mappingProfiles.png')
      }
    },
    "jobProfiles": {
      "alt": "Job Profiles",
      "title": "Job Profiles",
      "high": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/jobProfiles.svg')
      },
      "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/jobProfiles.svg'),
      "low": {
        "src": require('/var/lib/jenkins/remote-root-dir/workspace/fse-build-tenant-ui/platform/node_modules/@folio/stripes-data-transfer-components/icons/jobProfiles.png')
      }
    }
  }
};
      export { okapi, config, modules, branding, errorLogging, translations, metadata, icons };
    